var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media / Stop_Circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1 13C1 19.6275 6.37259 25 13 25C19.6275 25 25 19.6275 25 13C25 6.37259 19.6275 1 13 1C6.37259 1 1 6.37259 1 13Z",
    stroke: "#1B224C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.0007 14.8661V11.1328C17.0007 10.3861 17.0002 10.0131 16.8549 9.72787C16.7271 9.47699 16.5238 9.27316 16.273 9.14532C15.9878 9 15.6137 9 14.8669 9H11.1335C10.3869 9 10.0138 9 9.7286 9.14532C9.47772 9.27316 9.27389 9.47699 9.14605 9.72787C9.00073 10.0131 9.00073 10.3861 9.00073 11.1328V14.8661C9.00073 15.6129 9.00073 15.9871 9.14605 16.2723C9.27389 16.5231 9.47772 16.7264 9.7286 16.8541C10.0138 16.9995 10.3869 17 11.1335 17H14.8669C15.6137 17 15.9878 16.9995 16.273 16.8541C16.5238 16.7264 16.7271 16.5231 16.8549 16.2723C17.0002 15.9871 17.0007 15.6129 17.0007 14.8661Z",
    stroke: "#1B224C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopCircle);
export default __webpack_public_path__ + "static/media/Stop_Circle.6cac210c3ed34fa1782cb36a7198fd1e.svg";
export { ForwardRef as ReactComponent };